// extracted by mini-css-extract-plugin
export default {"wrap":"mH-z","articleImagesWrap":"nH-z","articleImage":"oH-z","singleImage":"pH-z"};